<button class="ins-buttons no-border button-primary flint w-100"
        translate data-automation-id="place-hold-btn"
        [attr.aria-describedby]="ariaDescribedBy"
        (click)="onGetItRollUp($event)">
  {{ newEditionsUxDesignEnabled ? 'requestAnyEdition' : 'placeHold' }}
</button>
